/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Claims_TitleInputs */

const en_home_benefit_claims_title = /** @type {(inputs: Home_Benefit_Claims_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Claims Support`)
};

const fr_home_benefit_claims_title = /** @type {(inputs: Home_Benefit_Claims_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutien aux réclamations 24/7`)
};

/**
* | output |
* | --- |
* | "24/7 Claims Support" |
*
* @param {Home_Benefit_Claims_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_claims_title = /** @type {((inputs?: Home_Benefit_Claims_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Claims_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_claims_title(inputs)
	return fr_home_benefit_claims_title(inputs)
});